import React, { useEffect, useState } from "react";
import "./WebSplash.css";

// Module-level flag: show the splash once per full page load (not on
// client-side route changes between Login and Landing). A hard refresh
// reloads this module and resets the flag, so the splash shows again.
let hasShownSplash = false;

export default function WebSplash() {
    const [visible, setVisible] = useState(!hasShownSplash);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        if (!visible) return;
        hasShownSplash = true;

        const fadeTimer = setTimeout(() => setFading(true), 1500);
        const hideTimer = setTimeout(() => setVisible(false), 2050);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(hideTimer);
        };
    }, [visible]);

    if (!visible) return null;

    return (
        <div className={`web-splash${fading ? " web-splash--hide" : ""}`} role="status" aria-label="Loading">
            <div className="web-splash__glow" />
            <div className="web-splash__inner">
                <div className="web-splash__logo-wrap">
                    <img
                        src={process.env.PUBLIC_URL + "/image/VSB-logo.png"}
                        alt="Vaidhi Sadhana Bhakti"
                        className="web-splash__logo"
                    />
                </div>
                <h1 className="web-splash__title">Vaiḍhī Sādhana Bhakti</h1>
                <p className="web-splash__subtitle">Track your daily sādhana with devotion</p>
                <div className="web-splash__spinner" aria-hidden="true">
                    <span />
                    <span />
                    <span />
                </div>
            </div>
        </div>
    );
}
